module.exports = __webpack_public_path__ + "static/default-share-image-32aca39e1373e57ffe54c6e64366dab1.jpg";